import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Control, Form, Errors, actions } from 'react-redux-form'

// Actions
import {
	fetchUserSharedValueStories,
	fetchValueStoriesLoading,
	fetchValueStoriesSuccess,
	fetchValueStoriesFailure,
	addValueStory,
	addValueStorySuccess,
	addValueStoryFailure,
	openValueStory,
	openValueStorySuccess,
	openValueStoryFailure,	
	resetMessage,
	resetError,
	isSharedValueStoryOpen
}
	from 'actions/userActions'

import {
	initPrioritiesItems
}
	from 'actions/prioritiesActions'

import { valueStoryFetchDataSuccess } from 'actions/fetchValueStory'
import {
	setValueStoryDmciDetails,
	setResultSummaryDetails,
	setTopDetails
} from 'actions/spendActions'

// Components
import SharedValueStoryList from './SharedValueStoryList'

// UI
import Button from 'UI/Button'
import Textfield from 'react-mdl/lib/Textfield'
import Select from 'react-select'  //'react-virtualized-select'
import { BreakLine } from '../../utils/Utils'

// Settings
import { modalStyle, modalContentStyle, routes, validators } from 'Constants'
import Modal from 'reboron/OutlineModal'
import ValueStoryShare from './ValueStoryShare'
import { valueStory_discovery_DropdowStyles } from 'react-select-css'
//CSS
//import '../../styles/value-story-select.css'

const valueStoryModalContentStyle = Object.assign({}, modalContentStyle);
valueStoryModalContentStyle.padding = "20px";

const valueStoryModalStyle = Object.assign({}, modalStyle);
valueStoryModalStyle.width = "100%";
valueStoryModalStyle.maxWidth = "1250px";
valueStoryModalStyle.height = "99%";

const defaultOptions = [
	{ value: 0, label: "" }];

const BLURPENAME = '|BLURPENAME';



class SharedValueStories extends Component {

	constructor(props) {
		super(props)

		this.state = {
			selectedValueStory: null,
			isShared: null,
			responseMsg: '',
			isanySharedStory: false,
			isanyCreatorStory: false,
			selectedPEName: '',
			selectedPEId: '',
			filterdPENameOptions: [],
			filterdPEIdOptions: [],
			contentPE: []
		}

		this.fetchUserSharedValueStories = this.fetchUserSharedValueStories.bind(this)
		this.handleValueStoryClick = this.handleValueStoryClick.bind(this)
		this.openValueStory = this.openValueStory.bind(this)
		this.dispatchOpenValueStory = this.dispatchOpenValueStory.bind(this)
		this.redirect = this.redirect.bind(this)
		this.showModal = this.showModal.bind(this)
		this.hideModal = this.hideModal.bind(this)
		this.actions = this.getApplicationFeatureActions();
	}

	handleValueStoryClick(VSId) {
		this.setState({
			selectedValueStory: VSId
		})
	}

	clearSpendData() {
		this.props.setValueStoryDmciDetails([])
		this.props.setResultSummaryDetails([])
		this.props.setTopDetails([])
	}

	openValueStory() {
		this.props.isSharedValueStoryOpen(this.state.selectedValueStory, this.props.user.user.Id)
			.then((response) => {
				if (response.status === 200) {
					this.dispatchOpenValueStory()
					this.props.hideModal('valueStory')
					this.clearSpendData()
				}
				else {
					var content = this.props.content;
					var httpStattus = response.response.data.Message
					var failMsg = content[httpStattus]
					if (failMsg !== undefined) {
						failMsg = failMsg.toString().replace("%userName%", response.response.data.Result)
						this.props.openValueStoryFailure(failMsg)
					}
				}
			}).catch((error) => {
				//console.log(error)
				//this.props.openValueStoryFailure(error.response.data.Message)
			})
	}

	dispatchOpenValueStory() {
		var content = this.props.content;
		this.state.selectedValueStory &&
			this.props.openValueStory(this.state.selectedValueStory, this.props.user.user.Id)
				.then((response) => {
					if (response.status === 200) {
						//this.props.hideModal('valueStory')
						// Push value story data to store
						this.props.valueStoryFetchDataSuccess(response.data.Result)

						// Add indexes of selected priorities to priorities array in store
						let items = response.data.Result.AreaOfInterest.map((item, i) => item.Selected && i)
						items = items.filter((item) => item !== false)
						this.props.initPrioritiesItems(items)

						// Reset form
						//this.formDispatch(actions.reset('addValueStory'))

						// Redirect to Discovery page
						this.redirect()

						// update store status message
						// this.props.openValueStorySuccess()

						// reset store status message
						//setTimeout(() => {this.props.resetMessage()}, 100)
					}
					else {
						// setTimeout(() => {
						// 	this.props.showModal('valueStory')
						// }, 1000);

						var httpStattus = response.response.data.Message
						var failMsg = content[httpStattus]
						if (failMsg !== undefined) {
							failMsg = failMsg.toString().replace("%userName%", response.response.data.Result)
							this.props.openValueStoryFailure(failMsg)
						}
					}
				}).catch((error) => {
					//console.log(error)
					//this.props.openValueStoryFailure(error.response.data.Message)
				})
	}

	fetchUserSharedValueStories() {
		this.props.fetchValueStoriesLoading(true)
		this.props.fetchUserSharedValueStories(this.props.user.user.Id)
			.then((result) => {
				if (result.status === 200) {
					this.props.fetchValueStoriesSuccess(result)
					for (var i = 0; i < result.data.Result.length; i++) {
						var obj = result.data.Result[i];
						if (obj.Id !== localStorage.getItem('id')) {
							this.setState({
								isanySharedStory: true
							})
							break;
						}
					}
					for (var i = 0; i < result.data.Result.length; i++) {
						var obj = result.data.Result[i];
						if (obj.Id === localStorage.getItem('id')) {
							this.setState({
								isanyCreatorStory: true
							})
							break;
						}
					}
				}
			}).catch((error) => {
				 if(error.response !== undefined && error.response.data !== undefined && error.response.data.Message !== undefined) {
					this.props.fetchValueStoriesFailure(error.response.data.Message)
				}
				// else if (error.stack.includes('Network Error')) {
				// 	this.props.fetchValueStoriesFailure('API service is down. Please contact administrator.')
				//   }

			})
	}

	showModal(action, vsid, isShared) {
		this.setState({
			selectedValueStory: vsid,
			isShared: isShared
		})
		this.refs[action].show()
	}

	hideModal(action) {
		this.refs[action].hide()
	}

	redirect() {
		//this.props.history.push(`/discovery`)
		//this.props.history.push(this.actions.indexOf(routes.businessValue)> -1 ?  `/discovery` : `/yourSpend`)
		if(this.actions.indexOf(routes.yourSpend)> -1)
		{
           this.props.history.push(this.actions.indexOf(routes.businessValue)> -1 ?  `/discovery` : `/yourSpend`)		
		}
		else{
			this.props.history.push(`/discovery`)
		}
	}

	componentWillMount() {
		this.fetchUserSharedValueStories();
		//this.storePEData();
	}

	showShareValueStory() {
		var resp = Object.values(this.props.user.user.applicationFeatures).map(feature => {
			if (this.props.content[feature.Action] !== undefined) {
				return true;
			}
		})
		if (resp.indexOf(true) > 0) {
			return true;
		}
	}

	componentWillUnmount() {
		//this.formDispatch(actions.reset('addValueStory'))
		this.props.resetError();
	}

	getApplicationFeatureActions() {
		let actions = [];
		let applicationFeatures = this.props.user && this.props.user.user && this.props.user.user.applicationFeatures ? this.props.user.user.applicationFeatures : [];
		applicationFeatures.map(applicationFeat => {
			actions.push(applicationFeat.Action);
		})
		return actions;
	}


	render() {
		return (
			<div className="valuestory popup-content medium-12">
				<div className="grid-x">
					<div className="medium-12">
						{/* <div className="title">{this.props.content.editStory}</div> */}
						<SharedValueStoryList
							valueStories={this.props.user.valueStories}
							handleValueStoryClick={this.handleValueStoryClick}
							openValueStory={this.openValueStory}
							selectedValueStory={this.state.selectedValueStory}
							showModal={this.showModal}
							hideModal={this.hideModal}
							isanySharedStory={this.state.isanySharedStory}
							isanyCreatorStory={this.state.isanyCreatorStory}
							email={this.props.user.user.Email}
							enableShareValueStory={this.showShareValueStory()}
							content={this.props.content}
							isCustomer={this.props.isCustomer}
						/>
						{
							this.state.responseMsg !== "" ?
								<div className="success">{this.state.responseMsg}</div>
								: <div className="errors">{this.props.user.error}</div>
						}

						{
							(this.props.user.valueStories.length === 0) ?
								<div className="grid-x">
									<div className="medium-12">									
									</div>
								</div>
								:
								// Remove below line once get approval to rollout sharing logic to partners as well
								(this.showShareValueStory() && !this.props.isCustomer) ?
									<div className="grid-x grid-padding-x">
										<div className="medium-5">
											{(this.state.isanyCreatorStory === true) ?
												<div className="medium-12">
													<img width="23" src="images/share-value-story.png" />
													<span style={{ 'fontSize': '12px' }}>{this.props.content.creatorStroy}</span>
												</div>
												: null
											}
											{(this.state.isanySharedStory === true) ?
												<div className="medium-12 pt5">
													<img width="23" src="images/shared-details.png" />
													<span style={{ 'fontSize': '12px' }} >{this.props.content.sharedStroy}</span>
												</div>
												: null
											}
										</div>

									</div>
									: null}
					{this.props.user.valueStories.constructor === Array ? 
						<div className="grid-x grid-padding-x">
							<div className="medium-12">
								<div className="float-right">									
									<div className="float-left">
										<Button
											onClick={this.openValueStory}
											disabled={this.props.user.loading}
											content={this.props.content.open}
											color
										/>
									</div>
								</div>
							</div>
						</div>
					: null}
					</div>
				</div>
				<div>
					<Modal
						ref="shareValueStory"
						modalStyle={valueStoryModalStyle}
						contentStyle={valueStoryModalContentStyle}>
						{this.props.user.valueStories.constructor === Array ? 
						<ValueStoryShare
						    SelectedVSData = {this.props.user.valueStories.filter(vs=>vs.VSId == this.state.selectedValueStory)}
							VSId={this.state.selectedValueStory}
							Content={this.props.content}
							IsShared={this.state.isShared}
						/>
						:<span style={{color:'red'}}>this.props.user.valueStories.payload</span>}
						<button onClick={() => this.hideModal('shareValueStory')} className="close" />
					</Modal>
				</div>
			</div>

		)
	}
}

const mapStateToProps = (state) => {
	return {
		language: state.language,
		user: state.default,
		userData: state.valueStory,
		valueStoryHasErrored: state.valueStoryHasErrored,
		valueStoryIsLoading: state.valueStoryIsLoading,
		validation: state.content.validation,
		contentPE: state.contentPE
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchUserSharedValueStories: (id) => dispatch(fetchUserSharedValueStories(id)),
		fetchValueStoriesLoading: (bool) => dispatch(fetchValueStoriesLoading(bool)),
		fetchValueStoriesSuccess: (valueStories) => dispatch(fetchValueStoriesSuccess(valueStories)),
		fetchValueStoriesFailure: (error) => dispatch(fetchValueStoriesFailure(error)),
		initPrioritiesItems: (items) => dispatch(initPrioritiesItems(items)),
		addValueStory: (formValues) => dispatch(addValueStory(formValues)),
		addValueStorySuccess: (valueStory) => dispatch(addValueStorySuccess(valueStory)),
		addValueStoryFailure: (error) => dispatch(addValueStoryFailure(error)),	
		openValueStory: (VSId, Id) => dispatch(openValueStory(VSId, Id)),
		openValueStorySuccess: () => dispatch(openValueStorySuccess()),
		openValueStoryFailure: (error) => dispatch(openValueStoryFailure(error)),
		isSharedValueStoryOpen: (VSId, Id) => dispatch(isSharedValueStoryOpen(VSId, Id)),
		valueStoryFetchDataSuccess: (valueStory) => dispatch(valueStoryFetchDataSuccess(valueStory)),
		resetMessage: () => dispatch(resetMessage()),
		resetError: () => dispatch(resetError()),
		setValueStoryDmciDetails: (data) => dispatch(setValueStoryDmciDetails(data)),
		setResultSummaryDetails: (data) => dispatch(setResultSummaryDetails(data)),
		setTopDetails: (data) => dispatch(setTopDetails(data))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SharedValueStories)
